import { t } from "../../hooks/useAppTranslation";
import styles from "./ExternalControlStyle.module.scss";

type Props = {
  controlId?: string;
  name?: string;
  beneficiaryId?: string;
  number?: string;
  title?: string;
  controlNumber?: string;
  mode: string;
  error?: string;
  handleProjNumberPopup(): void;
};

export const IdInfoSect: React.FC<Props> = ({
  controlId,
  name,
  error,
  beneficiaryId,
  number,
  title,
  controlNumber,
  mode,
  handleProjNumberPopup,
}) => {
  return (
    <>
      <h3 className={styles.headerLabel}>{t('external-controls-identification-data')}</h3>
      <div className="row align-items-center">
        { mode !== 'edit' && <div className="col-md-6">
          <button
            className="btn save-btn uppercase"
            type="button"
            onClick={handleProjNumberPopup}
          >
            + {t('external-controls-select-project-number')}
          </button>
        </div>}
        <div className="col-md-6">
          <p className={styles.disabledLabelHeader}>{t('external-controls-project-number')}</p>
          <div className={styles.disabledLabel}>
            {number ? number : t('external-controls-project-number')}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <p className={styles.disabledLabelHeader}>{t('external-controls-beneficiary-name')}</p>
          <div className={styles.disabledLabel}>
            {name ? name : t('external-controls-beneficiary-name')}
          </div>
        </div>
        <div className="col-md-6">
          <p className={styles.disabledLabelHeader}>
            {t('external-controls-beneficiary-id')}
          </p>
          <div className={styles.disabledLabel}>
            {beneficiaryId ? beneficiaryId : t('external-controls-beneficiary-id')}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <p className={styles.disabledLabelHeader}>{t('external-controls-control-number')}</p>
          <div className={styles.disabledLabel}>
            {controlNumber && mode === "edit"
              ? controlNumber
              : t('external-controls-control-number')}
          </div>
        </div>
        <div className="col-md-6">
          <p className={styles.disabledLabelHeader}>{t('external-controls-project-title')}</p>
          <div className={styles.disabledLabel}>
            {title ? title : t('external-controls-project-title')}
          </div>
        </div>
      </div>

      {error && <p style={{ color: "#EB0000" }}>{error}</p>}
    </>
  );
};
